module.exports = __webpack_public_path__ + "img/Wind.6b4d1006.svg";